import React, {useEffect, useRef, useState} from 'react';
import cl from "./FormUrlInput.module.css";
import {FormHelperText, IconButton, TextField, Tooltip} from "@mui/material";
import NavLinkIcon from "../components/Icons/NavLinkIcon";
import FormControlCaption from "./FormControlCaption";
import "./helperText.css";

const FormUrlInput = ({label, initValue, widthLimit, controlRef, placeholder, tipText, readOnly, infoText}) => {

    const inputRef = useRef(null);
    const [errorMessage, setErrorMessage] = useState("")

    const correctedWidthLimit = widthLimit === undefined ? 10000 : widthLimit;

    useEffect(() => {
        if (controlRef) {
            controlRef.current = {
                getUrl: getUrl,
                validateNotEmpty: validateNotEmpty,
                validateLength: validateLength,
                validateUrl: validateUrl,
                setErrorMessage: setErrorMessage,
            };
        }
    })

    function getUrl() {
        return inputRef.current.value.trim();
    }

    function validateNotEmpty(errorMessage) {
        if (getUrl().length > 0)
            return true;
        setErrorMessage(errorMessage);
        return false;
    }

    function validateLength(maxLength, errorMessage = undefined) {
        const textLength = getUrl().length;
        if (textLength <= maxLength)
            return true;
        setErrorMessage(errorMessage ?? `Слишком длинная строка! (нужно укоротить на ${textLength - maxLength} символ(ов))`);
        return false;
    }

    function validateUrl(errorMessage) {
        const value = getUrl();
        const regex = /^https?:\/\/\S+/
        if (regex.test(value) && testUrlParsable(value) && testUrlDecodable(value))
            return true;

        setErrorMessage(errorMessage);
        return false;
    }

    return (
        <div className={cl.main}>
            <FormControlCaption
                text={label}
                tipText={tipText}
            />
            <div style={{display: "flex", alignItems: "flex-start"}}>
                <TextField
                    type="text"
                    variant="outlined"
                    hiddenLabel
                    inputRef={inputRef}
                    defaultValue={initValue}
                    placeholder={placeholder}
                    error={errorMessage !== ""}
                    helperText={errorMessage}
                    /*disabled={true}*/
                    /*label={"test"}*/
                    sx={{width: `min(${correctedWidthLimit}px, 100%)`}}
                    slotProps={{
                        htmlInput: {
                            readOnly: readOnly,
                            sx: {backgroundColor: readOnly ? "#ffff0018" : "white", borderRadius: "4px"}
                        }
                    }}
                    onChange={() => {
                        if (errorMessage)
                            setErrorMessage("")
                    }}
                />
                <Tooltip title="Открыть ссылку в новой вкладке">
                    <IconButton
                        size="small"
                        /*sx={{'& .MuiSvgIcon-root': { fontSize: 16 }}}*/
                        sx={{scale: "0.85"}}
                        onClick={() => {
                            try {
                                const url = inputRef.current.value.trim();
                                if (url)
                                    window.open(url, "_blank", "noreferrer");
                            } catch (error) {
                            }
                        }}>
                        <NavLinkIcon fgColor="#446688"/>
                    </IconButton>
                </Tooltip>
            </div>
            {infoText && <FormHelperText sx={{marginLeft:"14px"}} className="helperText">
                {infoText}
            </FormHelperText>}
        </div>
    );
};

function testUrlParsable(url) {
    if (URL.canParse)
        return URL.canParse(url);

    // Fallback for Safari 16 and older
    try {
        new URL(url);
        return true;
    } catch {
        return false;
    }

}

function testUrlDecodable(url) {
    try {
        decodeURI(url);
        return true;
    } catch {
        return false;
    }
}

export default FormUrlInput;